// component

import { ICreatorRankDB } from 'type/db';

import TableCell from 'components/common/table/cell/TableCell';
import CorePictureAvatar from 'shared/avatar/CorePictureAvatar';
import CoreTag from 'shared/tag/CoreTag';
import { EllipsisText } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';
// utils
import { setCategoryColor } from 'utils/colorType';
import round, { floatFixed, roundFloat } from 'utils/round';
// type
import { creator_ranking_header_arr } from 'utils/table';

const useCreatorRankTable = () => {
	/** cell_type이 number인 cell */
	const numberCell = (value: number | null, unit: string, idx: number) => {
		const result = value === null ? '-' : `${round(value, 'round')} ${unit}`;
		return (
			<TableCell _width={creator_ranking_header_arr[idx].width} cell_type="number">
				{result}
			</TableCell>
		);
	};
	/** cell_type이 percent인 cell */
	const percentCell = (value: number | null, idx: number) => {
		const result =
			value === null ? '-' : floatFixed(roundFloat(value, 'round', 2), 2) + '%';
		return (
			<TableCell _width={creator_ranking_header_arr[idx].width} cell_type="number">
				{result}
			</TableCell>
		);
	};
	// 리턴할 객체
	const match_cell_mapper: Record<
		string,
		(data: ICreatorRankDB, idx: number, row_idx: number) => JSX.Element
	> = {
		NO: (data, idx, row_idx) => (
			<TableCell _width={creator_ranking_header_arr[idx].width}>{row_idx + 1}</TableCell>
		),

		rankChange: (data, idx) => (
			<TableCell _width={creator_ranking_header_arr[idx].width} _padding="0 10px">
				<Text
					typo="span_bold"
					style={{
						color: data.rankChange > 0 ? 'blue' : data.rankChange < 0 ? 'red' : 'black',
					}}
				>
					{data.rankChange > 0 && `(▲${Math.abs(data.rankChange)})`}
					{data.rankChange < 0 && `(▼${Math.abs(data.rankChange)})`}
					{data.rankChange === 0 && `(-)`}
				</Text>
			</TableCell>
		),

		creator: (data, idx) => (
			<TableCell _width={creator_ranking_header_arr[idx].width} _padding="0 10px">
				<Grid flex="start" _gap="16px" _padding="0 0 0 16px">
					<CorePictureAvatar
						size="default"
						color_type="blue"
						text={data?.username}
						picture={data?.profileImage}
					/>
					<Grid flex="start" direction="column" align_items="start">
						<Grid _width="160px" flex="start" _gap="8px">
							<EllipsisText typo="p_bold">{data?.username}</EllipsisText>
						</Grid>
						<EllipsisText _width="160px" typo="span">
							{data?.biography}
						</EllipsisText>
					</Grid>
				</Grid>
			</TableCell>
		),
		category: (data, idx) => (
			<TableCell _width={creator_ranking_header_arr[idx].width} _padding="0 10px">
				<Grid flex="start">
					{data?.category1 && (
						<CoreTag
							tag_type="text"
							color_type={setCategoryColor(data?.category1)}
							value={data?.category1}
						/>
					)}
					{data?.category2 && (
						<CoreTag
							tag_type="text"
							color_type={setCategoryColor(data?.category2)}
							value={data?.category2}
						/>
					)}
				</Grid>
			</TableCell>
		),
		audience: (data, idx) => (
			<TableCell _width={creator_ranking_header_arr[idx].width} _padding="0 10px">
				<Grid flex="end" align_items="start">
					<Text typo="span">
						{`${data?.audience.ageGroup}세 ${
							data?.audience.gender === 'F' ? '여성' : '남성'
						} (${data?.audience.percentage}%)`}
					</Text>
				</Grid>
			</TableCell>
		),
		follower: (data, idx) => numberCell(data?.followers, '명', idx),
		followerChange: (data, idx) => numberCell(data?.followerChange, '명', idx),
		// totalPerformanceScore: (data, idx) =>
		// 	numberCell(data?.totalPerformanceScore, '점', idx),
		rankingPoint: (data: ICreatorRankDB, idx: number, row_idx: number) => {
			const value = [
				data?.totalPerformanceScore,
				data?.reelsLikeCount,
				data?.styleClipLikeCount,
				data?.commentCount,
				data?.viewCount,
				data?.sentCount,
				data?.clickCount,
			]
				.filter(Boolean)
				.reduce((acc, val) => (acc || 0) + (val || 0), 0);

			return (
				<TableCell
					_width={creator_ranking_header_arr[idx].width}
					_padding="0 10px"
					cell_type="number"
				>
					{value?.toLocaleString()}
				</TableCell>
			);
		},
	};
	return match_cell_mapper;
};

const { Grid, Text } = style;

export default useCreatorRankTable;
